module.exports = __webpack_public_path__ + "static/pho4-96a817c8be0b52e8e719c939c3cd399d.jpg";